var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M10 0c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10C0 4.478 4.478 0 10 0zm0 1.667a8.333 8.333 0 100 16.666 8.333 8.333 0 100-16.666zm5.18 3.262c.098.143.098.332 0 .475l-2.756 3.98a2.5 2.5 0 01-3.04 3.04l-3.98 2.755a.417.417 0 01-.58-.58l2.754-3.98a2.5 2.5 0 013.041-3.04l3.98-2.755a.417.417 0 01.58.105zm-5.178 4.24a.833.833 0 100 1.666.833.833 0 000-1.667z",
        "fill": "var(--mainColor)",
        "fill-rule": "nonzero"
      }
    })]));
  }
};